export default __webpack_public_path__ + "static/media/Nicklaus_Icon_Logo.cf254967.png";